import { Customer } from '../../../domain/customers/customer';
import { CustomerList } from '../../../domain/customers/customerList';
import { CustomerDTO } from '../../http/dtos/customers/customerDTO';
import { CustomerListDTO } from '../../http/dtos/customers/customerListDTO';

const getCustomerListAdapter = (responseAPI: CustomerListDTO[]): CustomerList[] => {
    return responseAPI
        ? responseAPI.map((customer) => {
              return {
                  id: customer.id,
                  address: customer.address,
                  cityName: customer.cityName,
                  documentNumber: customer.documentNumber,
                  commercialName: customer.commercialName,
                  classification: customer.classification,
                  code: customer.code,
                  isActive: customer.isActive,
              };
          })
        : [];
};

const getCustomerAdapter = (responseAPI: CustomerDTO): Customer => {
    return {
        id: responseAPI.id,
        address: responseAPI.address,
        cityName: responseAPI.cityName,
        documentNumber: responseAPI.documentNumber,
        commercialName: responseAPI.commercialName,
        classification: responseAPI.classification,
        isActive: responseAPI.isActive,
        code: responseAPI.code,
        cityId: responseAPI.cityId,
    };
};

export const CustomerAdapter = {
    getCustomerListAdapter,
    getCustomerAdapter,
};
